import React from "react";
import styled from "styled-components";
import { SwipeableDrawer, withStyles } from "@material-ui/core";
import { UniDrawerList } from "./UniDrawerList";
const StyleLayout = styled.div`
  .menu {
    svg {
      position: relative;
      .st1 {
        position: absolute;
        top: 46.2px;
        left: 6.9px;
        transform-origin: 35px 0px;
        transition: all 0.2s ease-in-out;
      }
      .st2 {
        position: absolute;
        top: 21.2px;
        left: 6.9px;
        transform-origin: 15px 26px;
        transition: all 0.2s ease-in-out;
      }

      .st3 {
        position: absolute;
        top: 71.2px;
        left: 6.9px;
        transform-origin: 14px 35px;
        transition: all 0.2s ease-in-out;
      }
    }
    &.active {
      svg {
        position: relative;
        .st1 {
          transform: scale(0, 1);
        }
        .st2 {
          transform: rotate(45deg);
        }
        .st3 {
          transform: rotate(-45deg);
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .menu svg .st1 {
        left: auto;
        right: 0 !important;
        display: flex;
        align-content: flex-start;
    }
  }
`;

const SwipeStyle = withStyles((theme) => ({
  root: {
    "& .MuiDrawer-paper": {
      borderRadius: "0 0 30px 0",
      width: "300px",
      marginTop: "3.7rem",
      height: "calc(100% - 3.7rem)",
      backgroundColor: "var(--body-1)"
    },
    // '& .MuiBackdrop-root':{
    //     backgroundColor:'#00000000 !important'
    // },
    "@media screen and (max-width: 840px)": {
      "& .MuiDrawer-paper": {
        borderRadius: "0  ",
        marginTop: "0",
        height: "100%",
        width: "16rem",
        backgroundColor: "var(--body-2)"
      },
      // '& .MuiBackdrop-root':{
      //     backgroundColor:'#00000080 !important'
      // },
    },
  },
}))(SwipeableDrawer);
const SwipeStyle1 = withStyles((theme) => ({
  root: {
    "& .MuiDrawer-paper": {
      borderRadius: "0 30px 30px 0",
      top: "6rem",
      height: "90%",
      width: "28vw",
      boxShadow: "none",
      backgroundColor: "var(--body-1)"
    },
    // '& .MuiBackdrop-root':{
    //     backgroundColor:'#00000000 !important'
    // },
    "@media screen and (max-width: 1280px)": {
      "& .MuiDrawer-paper": {
        width: "30vw",
      },
    },
  },
}))(SwipeableDrawer);
const SwipeStyle2 = withStyles((theme) => ({
  root: {
    "& .MuiDrawer-paper": {
      borderRadius: "0 30px 30px 0",
      top: "5rem",
      bottom: "auto",
      height: "55%",
      width: "21vw",
      boxShadow: "none",
      backgroundColor: "var(--body-1)"
    },
    // '& .MuiBackdrop-root':{
    //     backgroundColor:'#00000000 !important'
    // },
    "@media screen and (max-width: 1280px)": {
      "& .MuiDrawer-paper": {
        width: "22vw",
      },
    },
  },
}))(SwipeableDrawer);

class UniDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Drawer: false,
      openGroup: -1,
    };
  }
  toggleDrawer = (isOpen) => {
    this.setState({
      Drawer: isOpen,
    });
  };


  Swiper = () => {
    if (this.props.costumorder) {
      if (this.props.active) {
        return (
          <SwipeStyle1
            anchor="left"
            open={this.state.Drawer}
            onOpen={() => this.toggleDrawer(true)}
            onClose={() => this.toggleDrawer(false)}
          >
            {/* {this.ListSide()} */}
            <UniDrawerList {...this.props} toggleDrawer={this.toggleDrawer}/>
          </SwipeStyle1>
        );
      } else {
        return (
          <SwipeStyle2
            anchor="left"
            open={this.state.Drawer}
            onOpen={() => this.toggleDrawer(true)}
            onClose={() => this.toggleDrawer(false)}
          >
            {/* {this.ListSide()} */}
            <UniDrawerList {...this.props} toggleDrawer={this.toggleDrawer}/>
          </SwipeStyle2>
        );
      }
    } else {
      return (
        <SwipeStyle
          anchor="left"
          open={this.state.Drawer}
          onOpen={() => this.toggleDrawer(true)}
          onClose={() => this.toggleDrawer(false)}
        >
          {/* {this.ListSide()} */}
          <UniDrawerList {...this.props} toggleDrawer={this.toggleDrawer}/>
        </SwipeStyle>
      );
    }
  };

  
  getDrawer = () => {
    let desableIcons = {};
    if (this.props.activeSearch) {
      desableIcons = {
        display: "none",
      };
      // if (window.innerWidth < 500) {
        
      // }
    }

    return (
      <React.Fragment>
        <div
          className={"nav-link menu " + (this.state.Drawer && "active")}
          style={desableIcons}
          onClick={() => this.toggleDrawer(true)}
        >
          <svg className="ham" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
            <path d="M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"/>
          </svg>
        </div>
        {this.Swiper()}
      </React.Fragment>
    );
  };

  render() {
    return <StyleLayout>{this.getDrawer()}</StyleLayout>;
  }
}

export default UniDrawer;
